<div class="row error-page-bg">
  <div class="col-md-12 text-center v-middle">
    <img src="assets/Venio_Logo_White_Transparent_BG.png" class="img-responsive m-b-20" height="50" alt="">
    <p class="display-1 m-b-0">{{ 't.401' | translate }}</p>
    <p class="display-4 m-b-40">{{ 'm.error.unauthorized' | translate }}</p>
    <button class="btn btn-outline-light" [routerLink]="['/login']">{{ 'l.login' | translate }}</button>
  </div>
</div>